<div [hidden]="!isLoading" class="text-xs-center">
  <i class="fa fa-cog fa-spin fa-3x"></i> <span>{{message}}</span>
</div>




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/loader/loader.component.html